const errorMsg = {
    "-1":"internet error please check ！",
    "100000":"account is not exists！",
    "100001":"account exception please admin ！",
    "100002":"account is not auth ！",
    "100003":"account password error ！",
};

export {
	errorMsg
}


// WEBPACK FOOTER //
// ./src/config/page/en/error/index.js